export const AuthenticationEndpoint = {
  LOGIN: '/user/auth/login',
  LOGOUT: '/user/auth/logout',
  REFRESH: '/user/auth/refresh',
};
